<template>
    <div id="left-menu" :class="{'left-menu-collapsed': collapsed}">

        <div v-if="this.whitelabeling_configuration_data.default_config">
            <div class="left-menu-header" v-if="!collapsed">
                <div class="col-md-4 left-menu-header-img-container">
                    <img class="left-menu-image" style="margin-bottom: 20px; width: 100px;"
                         src="../../assets/white_comodo_logo.png">
                    <img class="left-menu-image" src="../../assets/valkyrie-logo.svg">
                </div>
                <div class="col-md-8" style="position: relative;height: 100%; padding-left: 0;">
                    <div style="width: 100%; height: 35%; position: absolute; top:0; bottom:0;margin: auto">
                        <p class="left-menu-title" style="padding-top: 10px;">Valkyrie Threat</p>
                        <p class="left-menu-title">Intelligence</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!this.whitelabeling_configuration_data.default_config">
            <div class="left-menu-header-whitelabeling row" v-if="!collapsed">
                <div class="col-md-12 left-menu-header-img-container-whitelabeling">
                    <img class="left-menu-image-whitelabeling"
                         v-bind:src="this.whitelabeling_configuration_data.customer_ui_logo_path">
                </div>
                <div class="col-md-12" style="position: relative; padding-left: 0;">
                    <div style="width: 100%; height: 35%; position: absolute; top:0; bottom:0;margin: auto">
                        <p class="left-menu-title" style="padding-top: 10px;">
                            {{this.whitelabeling_configuration_data.name}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="item-container" :class="{'item-container-collapsed' : collapsed}" v-bar>
            <div>
                <div v-for="(mainItem, index) in items" v-bind:key="mainItem.mainTitle"
                     style="background-color: rgba(0, 0, 0, 0.1)">
                    <div
                        :class="{'left-menu-menu-title-container': true, 'left-menu-menu-title-container-dark': index % 2 == 0, 'left-menu-menu-title-container-light': index % 2 != 0}"
                        :mainTitle="mainItem.mainTitle"
                        v-on:mouseover="onMainItemMouseOver(mainItem.mainTitle)"
                        v-on:mouseout="onMainItemMouseOut(mainItem.mainTitle)"
                        @click="onMainItemClick(mainItem)"
                        :id="mainItem.mainTitle"
                        v-show="mainItem.show">
                        <div class="left-menu-menu-title-container-left-div"
                             :style="{'background-color': mainItem.color}"
                             :class="{'left-menu-menu-title-container-left-div-extended' : shouldExtendLeftDiv(mainItem)}">

                        </div>
                        <div class="left-menu-menu-title-container-right-div">
                            <p class="left-menu-menu-title" @mouseover="onMouseOverItem(mainItem)"
                               @mouseout="onMouseOutItem(mainItem)">{{mainItem.mainTitle.toUpperCase()}}
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(mainItem, $event)"
                                     @mouseout="onMouseOutTip()" v-show="mainItem.showQuestionMark"/>
                            </p>
                        </div>
                        <img v-if="mainItem.extendable"
                             :class="{'menu-title-arrow':true, 'menu-title-arrow-rotated' : !isExtended(mainItem.mainTitle)}"
                             src="../../assets/menu-arrow.svg" width="15px">
                    </div>
                    <div v-if="mainItem.extendable && isExtended(mainItem.mainTitle)"
                         v-for="(item,childindex) in mainItem.items"
                         :style="{'padding-top': childindex == 0 ? '15px' : '0px'}"
                         style="padding-right:10px;">
                        <div v-if="index==2  && childindex == 0"> <!--Partner selection-->
                            <div id="dvPartnerDropDown" v-show=true>
                                <dropdown :data="partnerNames"
                                          :cbChanged="changed"
                                          :width="250"
                                          :height="40"
                                          class="left-menu-partner-drop-down dp"
                                          placeholder="Loading..."
                                          :disabled="false"/>
                            </div>
                        </div>

                        <div class="item" :style="item.name == null ? 'display:none': ''"
                             v-bind:key="item.name" @click="itemClicked(item)">
                            <div class="col-md-10 item-text"
                                 :style="{'color': isSelectedPage(item.pageNumber) ? mainItem.color : 'white'}"
                                 @mouseover="onMouseOverItem(item)"
                                 @mouseout="onMouseOutItem(item)">
                                {{item.name}}<img width="15px" height="15px"
                                                  class="item-question-mark"
                                                  src="../../assets/question-mark-button.png"
                                                  @mouseover="onMouseOverTip(item, $event)"
                                                  @mouseout="onMouseOutTip()" v-show="item.showQuestionMark"/>
                            </div>
                            <div class="col-md-2 item-number" v-if="item.value" style="padding:0;">
                                <p style="width:100%" :class="checkToAddAlignment(item.value)">{{item.value}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="support-mail-container">
            <p align="center" style="margin-bottom: 0">
                {{this.whitelabeling_configuration_data.feedback_content_label}}</p>
            <p align="center" style="font-style: italic; font-size: 13px"><a
                v-bind:href="'mailto:' + this.whitelabeling_configuration_data.feedback_content_email"
                style="text-decoration: none; color: white">{{this.whitelabeling_configuration_data.feedback_content_email}}</a>
            </p>
        </div>
        <div class="progressBarPOC" v-show="showProgress">
            <div class="leftDay">
                <p v-if="remainingDay > 0">{{this.remainingDay }} Days left of your trial</p>
                <p v-if="remainingDay == 0">{{this.remainingDay}} Days left of your trial</p>
                <p v-if="remainingDay < 0">PoC completed {{this.completedDay}} days ago</p>
            </div>
            <div class="progressBar">
                <div id="progressBarAction"></div>
                <div class="percentageBox">
                    <div id="box">
                        <p id="percentage"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="left-menu-buttom">
            <logoutdropdown :visible="dropDownVisible" @clickout="dropDownVisible = false" :position="dropdownPosition">
                <div v-if="!avatarImage || avatarImage==='None'" @click="dropDownVisible=true">
                    <svg id="user-name-icon-text">
                        <text x="50%" y="64%" text-anchor="middle" fill="white">{{initials}}</text>
                    </svg>
                    <svg height="60" width="60" id="svg-circle-1" @click="dropDownVisible=true">
                        <circle cx="50%" cy="50%" r="30" fill="rgba(73, 82, 91, 1)"/>
                    </svg>
                </div>
                <div v-if="avatarImage && avatarImage!=='None'" @click="dropDownVisible=true">
                    <img :src="avatarImage" class="avatar">
                </div>
                <div class="dialog" slot="dropdown" @click="onUserIconClick()"
                     style="background-color: rgba(10, 11, 12, 1)" :style="{'margin-bottom' : manName ? 0 : '10px' }">
                    LOGOUT {{userInfo}}
                </div>
                <div class="dialog" slot="dropdown" @click="onDelegateManager()" v-if="manName"
                     style="background-color: rgba(16, 20, 26, 1); margin-bottom: 10px;">LOGIN AS {{manName}}
                </div>
            </logoutdropdown>
            <!--<img id="action-button-2" src="../../assets/actions_events_white.svg"/>-->
            <!--<img id="action-button-3" src="../../assets/control_filter_filter-black.svg"/>-->
            <!--@click="onUserIconClick()"-->
        </div>
        <global-tooltip ref="leftMenuGlobalTooltip"></global-tooltip>
    </div>
</template>

<script>

    const DASHBOARD_COLOR = "rgb(68, 237, 251)";
    const NOTIFICATIONS_COLOR = "rgb(117, 32, 250)";
    const GLOBAL_THREATS_COLOR = "rgba(255, 0, 67, 1)";
    const SETTINGS_COLOR = "rgb(0, 255, 174)";
    const SUPPORT_COLOR = "rgb(255, 163, 102)";
    const PARTNER_COLOR = "rgb(128, 215, 0)";
    const INDUSTRY_COLOR = "rgb(0, 179, 184)";

    const NOTIFICATION_FEED_INDEX = 1;
    const PARTNER_FEED_INDEX = 2;
    const INDUSTRY_FEED_INDEX = 3;
    const GLOBAL_FEED_INDEX = 4;
    const END_POINT_PARTNERS_GET = "/enterprise/partners/get";

    import Common from '@/utils/Common.vue'
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import PageNumbers from '@/utils/page-number-constants';
    import Constants from '@/utils/constants'
    import logoutdropdown from 'vue-my-dropdown'
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue'
    import help_contents from '@/assets/help_content.json'


    export default {
        components: {logoutdropdown, GlobalTooltip: GlobalTooltip},
        name: "left-menu",
        mixins: [Common],
        data() {
            return {
                items: [],
                selectedMainItemTitle: null,
                extendableMainItemTitles: {},
                selectedPage: null,
                hoveredMainItemTitle: null,
                dropDownVisible: false,
                dropdownPosition: ["right", "top", "left", "bottom"],
                manName: null,
                avatarImage: null,
                initials: "",
                isConnected: false,
                socketMessage: '',
                userInfo: null,
                hasPartner: false,
                remainingTrial: {},
                remainingDay: null,
                totalDay: null,
                currentDay: null,
                typeTrial: null,
                showProgress: false,
                partnerNames: [],
                partnerExists: false,
                resourceURL: null,
                completedDay: null,
                partnerBoolean: false,
                adminRole: null,
                whitelabeling_configuration_data: {},
                support_item_count: 5
            }
        },
        sockets: {
            connect() {
                // Fired when the socket connects.
                this.isConnected = true;
            },

            disconnect() {
                this.isConnected = false;
            },

            // Fired when the server sends something on the "messageChannel" channel.
            messageChannel(data) {
                this.socketMessage = data
            }
        },
        methods: {
            onMouseOverItem(item) {
                item.showQuestionMark = true;
            },
            onMouseOutItem(item) {
                item.showQuestionMark = false;
            },
            onMouseOverTip(item, e) {
                var rect = e.target.getBoundingClientRect();
                this.$refs.leftMenuGlobalTooltip.showTooltip(rect.top + 25, rect.left, item.help_content);
            },
            onMouseOutTip() {
                this.$refs.leftMenuGlobalTooltip.hideTooltip();
            },
            connectSocketIO() {
                var enterpriseId = this.getEnterpriseId;
                if (enterpriseId != null) {
                    this.getPartnerList();

                    this.$socket.emit('join', {room: enterpriseId});
                    this.$options.sockets.customer_feed_changed = (data) => {
                        this.updateNotificationsFeeds();
                        this.updateGlobalThreatsFeeds();
                        this.updatePartnerThreatsFeeds();
                    }
                }
            },
            getPartnerList() {
                var body = {
                    verbose: false,
                    ignore_empty_feed: false
                };

                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_PARTNERS_GET, body);
                promise.then(successData => {
                        this.partnerNames = [];
                        let selected = false;
                        this.partnerExists = successData.data.data.length > 1;

                        successData.data.data.forEach(d => {

                            this.$socket.emit('join', {room: String(d.customer_id)});

                            if (parseInt(d['customer_id']) == parseInt(this.getSelectedPartner)) {
                                selected = true;
                            }

                            var data = {
                                label: d['customer_name'],
                                value: d['customer_id'],
                                selected: (parseInt(d['customer_id']) == parseInt(this.getSelectedPartner))
                            };
                            this.partnerNames.push(data);
                        });
                        if (successData.data.data.length > 0) {
                            this.partnerBoolean = true;
                            this.showMenuItems(true);
                        } else {
                            this.partnerBoolean = false;
                            this.showMenuItems(false);
                        }
                        //check if the stored partner deleted
                        if (!selected) {
                            this.setSelectedPartner(null);
                        }

                        if (!this.getSelectedPartner || !selected) {
                            if (this.partnerNames.length > 0) {
                                this.partnerNames[0]["selected"] = true;
                                this.setSelectedPartner(this.partnerNames[0]["value"]);
                            }
                        }

                        this.getPartnerFeed();
                    },
                    failData => {
                        this.showMenuItems(false);
                        // console.log(JSON.stringify(failData));
                    }
                )
            },
            changed(selected) {
                if (selected[0].value != undefined && selected[0].value != null)
                    this.setSelectedPartner(selected[0].value);

                this.getPartnerFeed();
            },
            showMenuItems(showPartner) {
                for (var i = 0; i < this.items.length; i++) {
                    if (i == PARTNER_FEED_INDEX) {
                        if (showPartner != null) {
                            this.items[i].show = showPartner;
                        }
                    } else if (i != INDUSTRY_FEED_INDEX) {
                        this.items[i].show = true;
                    }
                }
            },
            fillDelegateInformation() {
                this.avatarImage = this.getComodoUserLogo;
                if (!this.avatarImage) {
                    const firstName = this.getUserFirstName;
                    const lastName = this.getUserLastName;
                    if (firstName != null && lastName != null) {
                        this.initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
                    }

                }
                this.manName = this.getComodoAdminName;
                this.userInfo = this.getUserFirstName == '' || this.getUserFirstName == null
                    ? this.getComodoUserObject : this.getUserFirstName + ' ' + this.getUserLastName;
            },
            updateNotificationsFeeds() {
                this.updateMenuCounts(NOTIFICATION_FEED_INDEX, "/enterprise/feed/get");
            },
            updatePartnerThreatsFeeds() {
                this.updateMenuCounts(PARTNER_FEED_INDEX, "/enterprise/partner/threat/feed/get");
            },
            updateGlobalThreatsFeeds() {
                this.updateMenuCounts(GLOBAL_FEED_INDEX, "/enterprise/global/threat/feed/get");
            },
            updateMenuCounts(itemIndex, urlPath) {
                // let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/feed/get");
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + urlPath);
                promise.then(function (result) {
                    if (itemIndex == PARTNER_FEED_INDEX) {
                        if (result.data.data.length == 0) {
                            this.items[PARTNER_FEED_INDEX].show = false;
                        } else {
                            this.items[PARTNER_FEED_INDEX].show = true;
                        }
                    }
                    result.data.data.forEach(function (feedItem) {
                        if (parseInt(feedItem.count[0]) > 0) {
                            let itemFound = this.items[itemIndex].items.find(item => item.name === feedItem.label);
                            if (itemFound) {
                                this.items[itemIndex].items.find((o) => {
                                    if (o.name === feedItem.label && o.value !== feedItem.count) {
                                        o.value = feedItem.count;
                                    }
                                });
                            } else {

                                let item = {
                                    name: feedItem.label,
                                    pageNumber: feedItem.pageNumber,
                                    value: feedItem.count,
                                    permission_id: String(feedItem.permission_id)
                                };
                                this.items[itemIndex].items.push(item);
                            }
                        } else {
                            this.items[itemIndex].items = this.items[itemIndex].items.filter(item => item.name !== feedItem.label)
                        }
                    }, this);
                });
            },
            getGlobalFeed() {
                var promiseGlobal = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/global/threat/feed/get");
                promiseGlobal.then(function (result) {
                    result.data.data.forEach(function (feedItem) {
                        if (parseInt(feedItem.count[0]) > 0) {
                            var item = {
                                name: feedItem.label,
                                pageNumber: feedItem.pageNumber,
                                value: feedItem.count,
                                help_content: feedItem.help_content,
                                showQuestionMark: false,
                                permission_id: String(feedItem.permission_id),
                                page_type: GLOBAL_FEED_INDEX
                            };
                            this.items[GLOBAL_FEED_INDEX].items.push(item);
                        }
                    }, this);
                });
            },
            getNotificationFeed() {
                var promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/feed/get");
                promise.then(function (result) {
                    result.data.data.forEach(function (feedItem) {
                        if (feedItem.value !== "threatScore") {
                            if (parseInt(feedItem.count[0]) > 0) {
                                var item = {
                                    name: feedItem.label,
                                    pageNumber: feedItem.pageNumber,
                                    value: feedItem.count,
                                    help_content: feedItem.help_content,
                                    showQuestionMark: false,
                                    permission_id: String(feedItem.permission_id),
                                    page_type: NOTIFICATION_FEED_INDEX
                                };
                                this.items[NOTIFICATION_FEED_INDEX].items.push(item);
                            }
                        } else {
                            var item = {
                                name: feedItem.label,
                                pageNumber: feedItem.pageNumber,
                                value: feedItem.count,
                                help_content: feedItem.help_content,
                                showQuestionMark: false,
                                permission_id: String(feedItem.permission_id),
                                page_type: NOTIFICATION_FEED_INDEX
                            };
                            this.items[NOTIFICATION_FEED_INDEX].items.push(item);
                        }

                    }, this);

                    if (self.$route != null) {
                        self.selectedPage = self.getPageNumberFromPath(self.$route.path);
                    }
                });
            },
            getIndustryFeed(id) {
                let request = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/industry/feed/get", {
                    "industry_id": id
                });
                request.then(function (response) {
                    response.data.data.forEach(function (feedItem) {
                        if (parseInt(feedItem.count[0]) > 0) {
                            var item = {
                                name: feedItem.label,
                                pageNumber: feedItem.page_number,
                                value: feedItem.count,
                                help_content: feedItem.help_content,
                                showQuestionMark: false,
                                permission_id: String(feedItem.permission_id),
                                page_type: INDUSTRY_FEED_INDEX
                            };
                            this.items[INDUSTRY_FEED_INDEX].items.push(item);
                        }
                    }, this);
                });
            },
            getPartnerFeed() {
                var data = {
                    partner_id: this.getSelectedPartner
                };
                var promiseGlobal = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/partner/threat/feed/get", data);
                promiseGlobal.then(function (result) {
                    this.items[PARTNER_FEED_INDEX].items = [];
                    let itemCount = 0;
                    result.data.data.forEach(function (feedItem) {
                        if (parseInt(feedItem.count[0]) > 0) {
                            var item = {
                                name: feedItem.label,
                                pageNumber: feedItem.pageNumber,
                                value: feedItem.count,
                                help_content: feedItem.help_content,
                                showQuestionMark: false,
                                permission_id: String(feedItem.permission_id),
                                page_type: PARTNER_FEED_INDEX
                            };
                            this.items[PARTNER_FEED_INDEX].items.push(item);
                            itemCount++;
                        }
                    }, this);

                    if (itemCount === 0) {
                        this.items[PARTNER_FEED_INDEX].items.push({
                            showQuestionMark: false,
                            page_type: PARTNER_FEED_INDEX
                        });
                    }
                });
            },
            getMenuCounts(industryInfo) {
                var self = this;
                this.getGlobalFeed();
                this.getNotificationFeed();
                if (industryInfo.industry_id > 0)
                    this.getIndustryFeed(industryInfo.industry_id);

                //partner feed request should be send after getPartnerList completition
                //this.getPartnerFeed();
            },
            checkEnterpriseIndustry() {
                var promiseGlobal = this.$http.get(Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/checkEnterpriseIndustry");
                promiseGlobal.then(function (response) {
                    let industryInfo = response.body;

                    this.createItems(industryInfo);
                    this.getMenuCounts(industryInfo);
                    this.fillDelegateInformation();
                    this.notificationExtendable();
                    this.showMenuItems(this.partnerBoolean);
                    this.getLicenseType();
                    this.dropdownStyles();
                });
            },
            createItems(industryItem) {
                var supportItemList = [];
                for (var i = 0; i < this.support_item_count; i++) {
                    var name = '';
                    var redirect = '';
                    let log_text = '';
                    if (i === 0) {
                        name = this.whitelabeling_configuration_data.ctrl_text;
                        redirect = this.whitelabeling_configuration_data.ctrl_link;
                        log_text = this.whitelabeling_configuration_data.ctrl_text + ' clicked.'
                    } else if (i === 1) {
                        name = this.whitelabeling_configuration_data.resources_text;
                        redirect = this.whitelabeling_configuration_data.resources_link;
                        log_text = this.whitelabeling_configuration_data.resources_text + ' clicked.'
                    } else if (i === 2) {
                        name = this.whitelabeling_configuration_data.api_sdk_text;
                        redirect = this.whitelabeling_configuration_data.api_sdk_link;
                        log_text = this.whitelabeling_configuration_data.api_sdk_text + ' clicked.'
                    } else if (i === 3) {
                        name = 'Feedback';
                        redirect = 'feedback';
                        log_text = 'Feedback clicked.'
                    } else if (i === 4) {
                        name = 'FAQ';
                        redirect = 'faq';
                        log_text = 'FAQ clicked.'
                    }
                    var support_item = {
                        name: name,
                        pageNumber: 'support',
                        order: i,
                        redirect: redirect,
                        logText: log_text
                    };
                    supportItemList.push(support_item);
                }

                this.items = [
                    {
                        mainTitle: "DASHBOARD",
                        selectable: true,
                        extendable: false,
                        color: DASHBOARD_COLOR,
                        pageNumber: PageNumbers.DASHBOARD.number,
                        showQuestionMark: false,
                        help_content: help_contents["DASHBOARD"],
                        show: false
                    },
                    {
                        mainTitle: "NOTIFICATIONS",
                        selectable: false,
                        extendable: true,
                        color: NOTIFICATIONS_COLOR,
                        items: [],
                        showQuestionMark: false,
                        help_content: help_contents["NOTIFICATIONS"],
                        show: false
                    },
                    {
                        mainTitle: "PARTNER THREATS",
                        selectable: false,
                        extendable: true,
                        color: PARTNER_COLOR,
                        items: [],
                        showQuestionMark: false,
                        help_content: help_contents["PARTNER_THREATS"],
                        show: false
                    },
                    {
                        mainTitle: 'INDUSTRY THREATS',
                        selectable: false,
                        extendable: true,
                        color: INDUSTRY_COLOR,
                        items: [],
                        showQuestionMark: false,
                        help_content: help_contents["INDUSTRY_THREATS"],
                        show: industryItem.industry_id > 0
                    },
                    {
                        mainTitle: "GLOBAL THREATS",
                        selectable: false,
                        extendable: true,
                        color: GLOBAL_THREATS_COLOR,
                        items: [],
                        showQuestionMark: false,
                        help_content: help_contents["GLOBAL_THREATS"],
                        show: false
                    },
                    {
                        mainTitle: "SETTINGS",
                        selectable: true,
                        extendable: false,
                        color: SETTINGS_COLOR,
                        pageNumber: PageNumbers.SETTINGS.number,
                        showQuestionMark: false,
                        help_content: help_contents["SETTINGS"],
                        show: false
                    },
                    {
                        mainTitle: "SUPPORT",
                        selectable: false,
                        extendable: true,
                        color: SUPPORT_COLOR,
                        items: supportItemList,
                        showQuestionMark: false,
                        help_content: help_contents["SUPPORT"],
                        show: false
                    }
                ];

                this.extendableMainItemTitles = {
                    "NOTIFICATIONS": false,
                    "PARTNER THREATS": false,
                    "GLOBAL THREATS": false,
                    "SETTINGS": false,
                    "SUPPORT": false
                };
                this.extendableMainItemTitles['INDUSTRY THREATS'] = false;
                this.selectedPage = this.items[0].pageNumber;
                this.showMenuItems(null);
            },
            setCollapsed(collapsed) {
                this.collapsed = collapsed;
            },
            setSelectedPage(pageNumber) {
                this.selectedPage = pageNumber;
            },
            itemClicked(item) {
                if (item.pageNumber != 'support') {
                    this.setSelectedPage(item.pageNumber);
                }
                this.$emit("itemClicked", item);
            },
            onMainItemMouseOver(mainItemTitle) {
                this.hoveredMainItemTitle = mainItemTitle;
            },
            onMainItemMouseOut(mainItemTitle) {
                if (this.hoveredMainItemTitle == mainItemTitle)
                    this.hoveredMainItemTitle = null;
            },
            onMainItemClick(mainItem) {
                if (mainItem.extendable) {
                    if (this.isExtended(mainItem.mainTitle)) {
                        this.extendableMainItemTitles[mainItem.mainTitle] = false;
                        this.hoveredMainItemTitle = null;
                    } else {
                        this.extendableMainItemTitles[mainItem.mainTitle] = true;
                        this.hoveredMainItemTitle = mainItem.mainTitle + "_";
                    }
                } else {
                    this.selectedPage = mainItem.pageNumber;
                    this.$emit("itemClicked", mainItem);
                }
            },
            isExtended(mainTitle) {
                return this.extendableMainItemTitles[mainTitle];
            },
            shouldExtendLeftDiv(mainItem) {
                return this.hoveredMainItemTitle == mainItem.mainTitle || this.selectedPage == mainItem.pageNumber
                    || this.isExtended(mainItem.mainTitle);
            },
            isSelectedPage(pageNumber) {
                return this.selectedPage == pageNumber;
            },
            onUserIconClick() {
                this.logOutUser();
            },
            onDelegateManager() {
                var managerSession = this.getManagerSession;
                var safeUrl = encodeURIComponent(managerSession);
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/logout')
                    .then(result => {
                        this.openInSameTab(Constants.ADMIN_UI_URL + "/login?session_id=" + safeUrl);
                    }, result => {
                        this.removeAllFromStore();
                        this.$router.go('/');
                    });
            },
            checkToAddAlignment(itemValue) {
                var REGEX = /(B|M|K)$/;
                if (!REGEX.test(itemValue)) {
                    return 'low-number-align';
                }
            },
            configureWhiteLabelVariables: function () {
                this.whitelabeling_configuration_data = this.getWhiteLabelingData;
                if (this.whitelabeling_configuration_data.default_config == true)
                    this.support_item_count = 5;
                else
                    this.support_item_count = 4;
            },
            notificationExtendable() {
                var state = this.getNotificationExtendable;
                this.extendableMainItemTitles = {
                    "NOTIFICATIONS": state,
                    "PARTNER THREATS": false,
                    "INDUSTRY THREATS": false,
                    "GLOBAL THREATS": false,
                    "SETTINGS": false,
                    "SUPPORT": false
                };
            },
            getLicenseType() {
                this.adminRole = this.getComodoAdminRole;
                var data = {
                    enterprise_id: this.getEnterpriseId
                };

                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/trial_customer', data)
                    .then(response => {
                        this.remainingTrial = response.data.data;
                        if (this.remainingTrial.length > 0) {
                            this.totalDay = this.remainingTrial[0].total_data;
                            this.currentDay = this.remainingTrial[0].current_data;
                            this.remainingDay = this.remainingTrial[0].remaining_trial_date;
                            this.completedDay = Math.abs(this.remainingDay);
                            this.typeTrial = this.remainingTrial[0].license_type;

                            if (this.typeTrial === 1 && this.getEnterpriseStatus == 7) {
                                this.showProgress = this.remainingDay >= 0 || this.remainingDay <= this.totalDay;
                            } else {
                                this.showProgress = false;
                            }

                            if (this.getUserRole(this.adminRole) == "TI_VI_MSSP_USER") {
                                this.showProgress = false;
                            }

                            //Progress Bar Start
                            var progressBar = document.getElementById('progressBarAction');
                            var box = document.getElementById('box');
                            var percentage = document.getElementById('percentage');
                            var totalWidth = 100 / this.totalDay;
                            var width = this.remainingDay * totalWidth;
                            if (this.remainingDay == 0) {
                                progressBar.style.width = (parseInt(this.currentDay) + 1) * totalWidth + '%';
                                box.style.marginLeft = '94%';
                                percentage.innerHTML = this.remainingDay;
                            } else if (this.remainingDay < 0) {
                                progressBar.style.width = this.totalDay * totalWidth + '%';
                                box.style.display = "none";
                                percentage.innerHTML = this.remainingDay;
                            } else {
                                progressBar.style.width = this.currentDay * totalWidth + '%';
                                box.style.marginLeft = this.currentDay * totalWidth + '%';
                                percentage.innerHTML = this.remainingDay;
                            }
                            //Progress Bar End
                        }

                    }, response => {

                    });
            },
            dropdownStyles() {
                var dropdownId = document.getElementById("left-menu-partner-drop-down");
                if (dropdownId != null) {
                    dropdownId.classList.remove("hsy-dropdown");
                    dropdownId.classList.add("dp");
                }
            },
            ...mapActions([
                "setSelectedPartner"
            ])
        },
        computed: {
            collapsed() {
                return this.getResponsiveState != this.RESPONSIVE_BIG;
            },
            ...mapGetters([
                "getResponsiveState",
                "getComodoAdminName",
                "getComodoAdminRole",
                "getManagerSession",
                "getComodoUserLogo",
                "getUserFirstName",
                "getUserLastName",
                "getEnterpriseId",
                "getComodoUserObject",
                "getNotificationExtendable",
                "getSelectedPartner",
                "getResourceURL",
                "getEnterpriseStatus",
                "getWhiteLabelingData"
            ])
        },
        watch: {
            partnerBoolean: function () {
                this.showMenuItems(this.partnerBoolean);
            }
        },
        mounted() {
            this.checkEnterpriseIndustry();
        },
        beforeMount() {
            this.connectSocketIO();
            this.configureWhiteLabelVariables();
        }
    }
</script>

<style>

    .support-mail-container {
        color: white;
    }

    #left-menu {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .left-menu-collapsed {
        position: absolute;
        top: 0px;
        left: 0;
        bottom: 10px;
        height: calc(100% - 50px) !important;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .left-menu-header {
        /*background-color:rgba(0, 0, 0, 0.5);*/
        background-color: black;
        padding: 10px;
        width: 100%;
        height: 240px
    }

    .left-menu-header-whitelabeling {
        background-color: black;
        padding: 10px;
        height: 240px;
    }

    .left-menu-header-img-container {
        position: relative;
        height: 100%;
    }

    .left-menu-header-img-container-whitelabeling {
        position: relative;
    }

    .left-menu-image {
        /*position: absolute;*/
        top: 0;
        bottom: 0;
        margin: auto;
        width: 80px;
    }

    .left-menu-image-whitelabeling {
        width: 120px;
        height: 120px;
        margin-left: 25%;
    }

    .left-menu-title {
        font-family: 'Digital-Serial-Regular';
        font-size: 25px;
        color: rgba(0, 255, 169, 1);
        text-align: center;
        line-height: 25px;
        text-shadow: 0px 0px 6px rgba(0, 255, 169, 1);
    }

    .left-menu-menu-title-container {
        width: 100%;
        height: 50px;
        cursor: pointer;
        position: relative;
    }

    .left-menu-menu-title-container-dark {
        background-color: rgba(0, 0, 0, 0.3)
    }

    .left-menu-menu-title-container-light {
        background-color: rgba(0, 0, 0, 0.2)
    }

    .left-menu-menu-title-container-left-div {
        width: 3%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        transition: width 0.5s;
    }

    .left-menu-menu-title-container-left-div-extended {
        width: 100%;
        transition: width 0.5s;
    }

    .left-menu-menu-title-container-right-div {
        width: 97%;
        height: 100%;
        position: absolute;
        left: 3%;
        z-index: 90;
    }

    .left-menu-menu-title {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        margin: auto;
        line-height: 50px;
        color: white;
        font-family: 'Digital-Serial-Bold';
    }

    .menu-title-arrow {
        position: absolute;
        right: 10px;
        top: 20px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }

    .menu-title-arrow-rotated {
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }

    .item-container {
        height: calc(100% - 450px);
    }

    .item-container-collapsed {
        height: 100%;
    }

    .item {
        color: white;
        font-family: 'Digital-Serial-Bold';
        font-size: 12px;
        padding: 0.8% 2.5% 2.5%;
        cursor: pointer;
        height: 35px;
        white-space: nowrap;
    }

    .item-text {
        text-align: left;
        padding-right: 0;
    }

    .item-question-mark {
        text-align: left;
        padding-right: 0;
        padding-left: 0;
        vertical-align: sub;
        margin-left: 3px;
    }

    .main-item-question-mark {
        text-align: left;
        padding-right: 0;
        padding-left: 0;
        vertical-align: sub;
        margin-left: 3px;
        margin-bottom: 1px;
    }

    .item-number {
        text-align: right;
        padding-right: 0;
    }

    .item:hover {
        margin-left: -10px;
        transition: all 0.1s;
    }

    .selected-item {
        color: rgba(0, 255, 169, 1);
    }

    .left-menu-buttom {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        z-index: 1000;
    }

    #action-button-1 {
        width: 60px;
        height: 60px;
        z-index: 3;
        position: absolute;
        top: 0;
        left: 5px;
        bottom: 0;
        margin: auto;
    }

    #action-button-2 {
        width: 60px;
        height: 60px;
        z-index: 3;
        position: absolute;
        top: 0;
        left: 90px;
        bottom: 0;
        margin: auto;
    }

    #action-button-3 {
        width: 60px;
        height: 60px;
        z-index: 3;
        position: absolute;
        top: 0;
        left: 160px;
        bottom: 0;
        margin: auto;
    }

    #user-name-icon-text {
        width: 60px;
        height: 60px;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 2;
        left: 5px;
        font-size: 20px;
        font-family: 'Digital-Serial-Bold';
        cursor: pointer;
    }

    #svg-circle-1 {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 1;
        left: 5px;
        cursor: pointer;

    }

    .dialog {
        z-index: 3;
        width: 300px;
        height: 50px;
        font-size: 14px;
        font-family: 'Digital-Serial-Bold';
        color: white;
        text-align: left;
        vertical-align: middle;
        line-height: 50px;
        cursor: pointer;
        padding-left: 20px;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .avatar {
        width: 60px;
        height: 60px;
        border-radius: 100px;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 1;
        left: 5px;
        cursor: pointer;
    }

    .low-number-align {
        margin-left: -10px;
    }

    .progressBarPOC {
        width: 100%;
        height: 75px;
        background-color: #151515;
        position: absolute;
        margin-top: 0px;
    }

    .leftDay p {
        padding: 5px 0 0 15px;
        color: white;
        font-size: 12px;
        font-family: 'Digital-Serial-Bold';
    }

    .progressBar {
        width: 90%;
        height: 10px;
        background-color: #73E3DE;
        margin-left: 15px;
        margin-top: 20px;
        z-index: auto;
    }

    #progressBarAction {
        width: 100%;
        height: 10px;
        background-color: #5e5e5e;
    }

    #box {
        width: 30px;
        height: 30px;
        background-color: #73E3DE;
        transform: rotate(45deg);
        border: 2px solid #1A1918;
        margin-top: -20px;
        margin-left: 45%;
    }

    #percentage {
        color: white;
        font-size: 15px;
        text-align: center;
        font-family: 'Digital-Serial-Bold';
        transform: rotate(-45deg);
        padding-right: 4px;
    }

    .hsy-dropdown {

    }

    #dvPartnerDropDown {
        background-color: #80d700;
        width: 90%;
        height: 40px;
        margin-left: 20px;
        margin-bottom: 10px;
    }

    .left-menu-partner-drop-down {
        font-family: 'Digital-Serial-Bold';
        background-color: #80d700;
        border: none;
        line-height: 40px;
        font-size: 12px;
        max-height: 40px;
        height: 40px;
        width: 250px;
        font-weight: bold;
        color: white !important;
        align-items: flex-start;
        text-align: left;
        background: url("../../assets/menu-arrow.svg") no-repeat 100% !important;
    }

    .hsy-dropdown {

    }

    .hsy-dropdown > .selected {
        border-radius: 3px !important;
        padding: 0 30px 0 10px !important;
        color: white !important;
        cursor: pointer !important;
        background: url("../../assets/menu-arrow.svg") no-repeat 100% !important;
        background-position-x: calc(100% - 10px) !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        border: 0 !important;
        align-items: flex-start !important;
        text-align: left !important;
        line-height: 40px !important;
        font-size: 14px !important;
        max-height: 40px !important;
        height: 40px !important;
        width: 350px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item {
        height: 40px !important;
        line-height: 40px !important;
        padding: 0 10px !important;
        cursor: pointer !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        background-position: 5px !important;
        text-align: left !important;
        margin-bottom: 1px !important;
        color: white !important;
        border-bottom: 1px solid #00fea9 !important;
        font-size: 14px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(odd) {
        background-color: #0a0b0c !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(even) {
        background-color: rgb(16, 20, 26) !important;
    }

    .hsy-dropdown > .list {
        position: absolute !important;
        top: 35px !important;
        left: 0 !important;
        font-size: 1.2em !important;
        box-shadow: 0 0 5px rgba(0, 0, 0, .2) !important;
        border-radius: 1px !important;
        z-index: 100 !important;
        background-color: black !important;
        border: 1px solid #00fea9 !important;
        font-family: 'Digital-Serial-Bold' !important;
        max-height: 300px !important;
        overflow-y: auto !important;
    }

    .hsy-dropdown > .list .item.selected {
        background: #00fea9 no-repeat 10px !important;
        border-radius: 3px !important;
        color: black !important;
        padding-left: 20px !important;
        width: 100% !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .hsy-dropdown > .list > .inner {
        padding: 2px 2px 0px 2px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/left-menu/LeftMenu.vue